module.exports = __webpack_public_path__ + "static/media/ficha-popupInformativo-content.65902a9a.jpg";